import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Support, TranslateHelper } from '@app/_helpers';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import * as _ from 'lodash';
import { ReplaySubject } from 'rxjs';
import { CollapseItemDirective, CollapseContentDirective } from '../../../shared/directives/collapse.directive';
import { IconComponent } from '../../../shared/components/icon/icon.component';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { CdkOverlayOrigin, CdkConnectedOverlay } from '@angular/cdk/overlay';
import { NgIf, NgFor, NgClass, AsyncPipe } from '@angular/common';

@UntilDestroy()
@Component({
    selector: 'app-select-search',
    templateUrl: './select-search.component.html',
    styleUrls: ['./select-search.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [
        NgIf,
        FormsModule,
        CdkOverlayOrigin,
        ReactiveFormsModule,
        CdkConnectedOverlay,
        NgScrollbarModule,
        NgFor,
        IconComponent,
        CollapseItemDirective,
        CollapseContentDirective,
        NgClass,
        AsyncPipe,
    ],
})
export class SelectSearchComponent implements OnInit {

    constructor(public translateHelper: TranslateHelper, public translate: TranslateService,
        private cdr: ChangeDetectorRef,

    ) { }

    FilterCtrl: UntypedFormControl = new UntypedFormControl();
    filteredList: ReplaySubject<any> = new ReplaySubject<any>(1);

    @Input() label;
    @Input() borderRadius = '0.25rem';
    @Input() appearance: 'legacy' | 'standard' | 'fill' | 'outline' | 'filter' = 'outline';
    @Input() floatLabel: 'always' | 'auto' = 'auto';
    @Input() placeholder = '';
    @Input() selectList;
    @Input() control: UntypedFormControl;
    @Input() multiple;
    @Output() selectChange: EventEmitter<any> = new EventEmitter();
    @Input() customLabel = '';


    @ViewChild("btnRef", { static: false }) btn;
    @ViewChild("btnIconRef", { static: false }) btnIcon;
    @ViewChild("btnLabelRef", { static: false }) btnLabel;

    selected = [];
    selectedList = [];

    selectedLabel = '';


    ngOnInit(): void {
        if (this.appearance == 'filter') {
            this.onFilterChange(null)
        }
        this.FilterCtrl.valueChanges.pipe(
            untilDestroyed(this)
        ).subscribe(value => this.onFilterChange(value));


        this.selected = [];
        this.selectedLabel = '';
        this.multiple = Support.numberToBoolean(this.multiple);

        if (this.multiple && this.control.value?.length) {
            _.forEach(this.selectList, (selectItem) => {
                if (selectItem.count !== 0 && this.control.value.includes(selectItem._id)) {
                    selectItem.selected = true
                    this.selected.push(selectItem.name[this.translate.currentLang]);
                    this.selectedList.push(selectItem);
                };
            })
        } else if (this.control.value) {
            _.forEach(this.selectList, (selectItem) => {
                if (selectItem.count !== 0 && this.control.value.includes(selectItem._id)) {
                    selectItem.selected = true
                    this.selected = [selectItem?.name[this.translate.currentLang] || ''];
                    this.selectedList = [selectItem];
                    return false;
                };
            })

        }
        this.selectedLabel = this.selected.join(', ')

    }
    onFilterChange(value: string, firstClick = false) {
        if (firstClick && this.selectedList.length && !this.FilterCtrl.value && this.appearance != 'filter') {
            this.filteredList.next(this.selectedList.slice())
            this.isOpen = true;
            this.cdr.detectChanges();
            return;
        }
        if (firstClick && this.appearance == 'filter') {
            return;
        }
        if (!this.selectList) {
            this.isOpen = false;
            return;
        }

        if (!value) {
            this.isOpen = false;
            this.filteredList.next(this.selectList.slice());
            return;
        } else {
            value = value.toLowerCase();
        }
        // filter the banks
        this.filteredList.next(
            this.selectList.filter(item => item.name[this.translate.currentLang].toLowerCase().indexOf(value) > -1)
        );

        this.isOpen = true;
        this.cdr.detectChanges();
    }
    onChange(e) {
        //if (this.multiple) return;
        this.selectChange.emit(e);
    }


    toggleSelectValue(value, item, event) {
        if (item.count === 0) return;
        if (this.multiple && !this.control.value?.length) this.control.setValue([]);
        item.selected = !item.selected;
        if (this.multiple) {
            let items = this.control.value || [];
            if (item.selected) {
                items.push(value);
                this.selected.push(item.name[this.translate.currentLang]);
                this.selectedList.push(item);
                this.control.setValue(items);
            } else {
                _.remove(items, (val, index) => {
                    if (val == value) {
                        this.selected.splice(index, 1);
                        this.selectedList.splice(index, 1);
                        return true;
                    }
                });
                if (!items) items = [];
                this.control.setValue(items);

            }
        }
        else {
            this.selected = [item?.name[this.translate.currentLang] || ''];
            this.selectedList = [item];
            this.control.setValue(value)
            this.isOpen = false;
        }

        event.preventDefault();
        event.stopPropagation();

        this.selectChange.emit(value);

        this.selectedLabel = this.selected.join(', ')
    }

    isOpen = false;

    menuClickOutside(event) {
        this.FilterCtrl.setValue(null);
        if (event.srcElement == this.btn?.nativeElement || event.srcElement == this.btnIcon?._elementRef?.nativeElement || event.srcElement == this.btnLabel?.nativeElement) {
            this.isOpen = false;
            event.preventDefault();
            event.stopPropagation();

        } else {
            let found = false;
            _.forEach(this.btnLabel?.nativeElement.children, child => {
                if (child == event.srcElement) {
                    found = true;
                    return false;
                }
            })
            this.isOpen = false;
            if (found) {
                event.preventDefault();
                event.stopPropagation();

            }

        }
    }

    toggleTrigger(evt) {
        this.isOpen = !this.isOpen;
        evt.preventDefault();
        evt.stopPropagation();
    }

    showMore(filterList?) {
        filterList.expanded = filterList.expanded === undefined ? true : !filterList.expanded;

        if (filterList.expanded) {
            filterList.classList.remove('show-more');
        } else {
            filterList.classList.add('show-more');
        }
    }
    public trackItem(index: number, item) {
        return item._id;
    }

}
